import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-almacen-menajeria',
  templateUrl: './almacen-menajeria.component.html',
  styleUrls: ['./almacen-menajeria.component.css']
})
export class AlmacenMenajeriaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
